import type { KeyPadConfig } from '../../../interfaces';
import type { KeypadConfigType } from '../../../interfaces/key-pad-config.enum';

/**
 * KeypadDisplay class
 */
export class KeypadDisplay {
  public keypadType: KeypadConfigType;
  public value = '';
  public config: KeyPadConfig;
  public onHold = false;
  public isDefaultMinValue = false;
  public shouldValidateMaxLength = true;

  public constructor(keypadType: KeypadConfigType, config: KeyPadConfig) {
    this.keypadType = keypadType;
    this.config = config;
  }
}
